class NavigationMenu extends HTMLElement {
    constructor(){
        super();
        this.buttons = [];
        this.mobileButton = null;
        this.topMenu = this.querySelector('ul');
        this.mediaQuery = window.matchMedia('(min-width: 1024px)');
        this.mediaQuery.addEventListener('change', this.toggleMobile.bind(this));
        this.toggleMobile(this.mediaQuery);
    }
    connectedCallback() {
        this.setupButtons();
    }
    setupButtons() {
        const sublists = this.querySelectorAll(':scope li > ul');
        sublists.forEach((item)=>{
            // Hide menu
            item.hidden = true;
            const parent = item.parentNode;
            // Move link to submenu
            let link = parent.querySelector('a');
            let firstItem = document.createElement('li');
            firstItem.append(link);
            item.prepend(firstItem);
            // Replace link with button
            const button = this.createButton(link.innerHTML);
            parent.prepend(button);
            button.addEventListener('click', this.toggle.bind(this));
            // Add button to this.buttons
            this.buttons.push(button);
        });
        // Once fully setup mark as ready.
        this.dataset.state = 'ready';
    }
    toggle(event) {
        event.preventDefault();
        let target = this.buttons.find((element)=>element == event.target);
        // If this button is being opened, close all others
        if (target.getAttribute('aria-expanded') === "false") {
            let active = this.buttons.filter((button)=>{
                return button.getAttribute('aria-expanded') === "true";
            });
            active.forEach((button)=>this.toggleButton(button));
        }
        // Finally toggle the event target
        this.toggleButton(target);
    }
    toggleButton(button) {
        // Toggle button
        let expanded = button.getAttribute('aria-expanded') === "true" ? true : false;
        button.setAttribute('aria-expanded', !expanded);
        // Show / hide ul
        const menu = button.nextElementSibling;
        menu.toggleAttribute('hidden');
    }
    toggleMobile(event) {
        if (event.matches) {
            // Remove button if exists
            if (this.mobileButton) this.mobileButton.remove();
            // Remove hidden from top-level menu
            this.topMenu.removeAttribute('hidden');
        } else {
            // Add button
            const button = this.createButton(this.dataset.text);
            this.prepend(button);
            this.mobileButton = button;
            button.addEventListener('click', this.toggleMobileButton.bind(this));
            // Hide top-level menu
            this.topMenu.hidden = true;
        }
    }
    toggleMobileButton() {
        this.toggleButton(this.mobileButton);
    }
    createButton(text) {
        const button = document.createElement('button');
        button.setAttribute('class', 'toggle');
        button.setAttribute('aria-expanded', false);
        button.innerHTML = text;
        return button;
    }
}
customElements.define("navigation-menu", NavigationMenu);

//# sourceMappingURL=index.fd7f9cf0.js.map
